/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { integrationsControllerConnectToProvider } from "./integrationsControllerConnectToProvider";
import { integrationsControllerGetTokenForProvider } from "./integrationsControllerGetTokenForProvider";
import { integrationsControllerListIntegrations } from "./integrationsControllerListIntegrations";
import { integrationsResourceControllerCreate } from "./integrationsResourceControllerCreate";
import { integrationsResourceControllerFindAll } from "./integrationsResourceControllerFindAll";
import { integrationsResourceControllerRemove } from "./integrationsResourceControllerRemove";
import { integrationsResourceControllerUpdate } from "./integrationsResourceControllerUpdate";

export function integrationsService() {
  return { integrationsResourceControllerCreate, integrationsResourceControllerFindAll, integrationsResourceControllerUpdate, integrationsResourceControllerRemove, integrationsControllerListIntegrations, integrationsControllerConnectToProvider, integrationsControllerGetTokenForProvider }
}